import ActionTypes from "./ActionTypes";

const getDashboardData = (payload) => {
  return {
    type: ActionTypes.GET_DASHBOARD_DATA,
    payload: payload,
  };
};

const getUserDetails = (payload) => {
  return {
    type: ActionTypes.GET_USER_DETAILS,
    payload: payload,
  };
};

const deactivateUserYardsale = (payload) => {
  return {
    type: ActionTypes.DEACTIVATE_USER_YARDSALE,
    payload: payload,
  };
};



export { getDashboardData, getUserDetails, deactivateUserYardsale };
